import styled from "styled-components";

import { themed, Flow, Stream, Button, Text as Tx, } from "@bracket/ui";
import { TokenAmountInput, } from "@components";
import { useSwap, } from "@store";



export declare type SwapInputProps = {
	showUSD?: boolean;
	inputName?: string;
	disabled?: boolean;
};



/**
 * A component that displays a token input field with balance information and max button.
 * Used as the input section of a swap interface.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} [props.inputName] - Label text to display above the input
 * @param {boolean} [props.disabled=false] - Whether the input is disabled
 * @returns {JSX.Element} A swap input component with token selector, amount input, and balance display
 */
export const SwapInput = ({
	inputName,
	disabled = false,
	showUSD = true,
}: SwapInputProps) => {
	themed();

	const { inputBalance, tokenIn, swapValueUSD, setInputMax, evaluation, } = useSwap();

	return (
		<Brace>
			{inputName && (
				<InputLabels>
					<Tx>{inputName}</Tx>
					{ !disabled && inputBalance && ( <Button variant="text" onClick={() => { setInputMax(); }} label="Max" style={{justifyContent: "flex-end"}} /> ) }
				</InputLabels>
      )}
			<Main>
				<TokenAmountInput disabled={disabled} />
				<DetailContainer>
					<DetailLeft><Tx sm color="subheading">Balance: {inputBalance} {tokenIn.symbol}</Tx></DetailLeft>
					<DetailRight>
						{ showUSD && <Tx sm color="subheading">USD: {swapValueUSD}</Tx> }
						{ evaluation !== "OK" && ( <SwapIssue><Tx sm color="warning">{evaluation}</Tx></SwapIssue> ) }
					</DetailRight>
				</DetailContainer>
			</Main>
		</Brace>
	);
};

const Brace = styled(Flow)`
	gap: 0rem;
`

const DetailContainer = styled(Stream)`
	justify-content: space-between;
	margin: 0.25rem 0;
	@media (min-width: 1024px) {
		margin: 0.5rem 0;
	}
`;

const Main = styled(Flow)`

`

const InputLabels = styled(Stream)`
	justify-content: space-between;
	margin-bottom: 8px;
`;

const DetailRight = styled(Stream)`
	justify-content: space-between;
`;

const DetailLeft = styled(Stream)`
	justify-content: space-between;
`;

const SwapIssue = styled(Stream)`
	justify-content: space-between;
`;
